import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { InlineInputGroup } from 'barnyard/components';
import ManufacturerSelect from '~/app/corporate/core/containers/ManufacturerSelect';


const InlineManufacturerSelect = (props) => {
  const {
    label,
    description,
    ...other
  } = props;

  return (
    <InlineInputGroup
      label={label}
      description={description}
      InputComponent={ManufacturerSelect}
      useNative={false}
      mode='multiple'
      showSearch={true}
      placeholder='Select manufacturer...'
      {...other}
    />
  );
};

InlineManufacturerSelect.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
};

InlineManufacturerSelect.defaultProps = {
  label: 'Manufacturer',
  description: 'Manufacturer to be included'
};

export default memo(InlineManufacturerSelect);
